import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { InvoiceItemFormValues } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Col, Form, FormInstance, Row } from 'antd';

interface NoteItemsIcmsTabsFormProps {
  form: FormInstance<InvoiceItemFormValues>;
}

export default function NoteItemsShareForm({
  form,
}: NoteItemsIcmsTabsFormProps) {
  return (
    <Form form={form} style={{ minHeight: 300 }}>
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'icmsBaseCalculationShare']}
            label="Base de Cálculo ICMS"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'fcpBaseCalculationShare']}
            label="Base de Cálculo FCP"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'icmsFcpPercentageShare']}
            label="Percentual ICMS FCP"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'internalAliquotShare']}
            label="Alíquota Interna"
          >
            <InputDecimal fractions={4} max={100} />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'interstateAliquotShare']}
            label="Alíquota Interestadual"
          >
            <InputDecimal fractions={4} max={100} />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'fcpRelativeIcmsShare']}
            label="ICMS relativo FCP"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <FloatingFormItem
            name={['itemTaxes', 'interstateIcmsShare']}
            label="ICMS Interestadual"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
